// UserAvatar — circular avatar with verified badge + initials fallback.
// Sizes: sm (32) · md (44) · lg (80) · xl (120).
import React from "react";
import { Link } from "react-router-dom";

const SIZES = {
  sm: { px: 32, font: 11, badge: 10 },
  md: { px: 44, font: 14, badge: 12 },
  lg: { px: 80, font: 24, badge: 18 },
  xl: { px: 120, font: 36, badge: 24 },
};

const initials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || "?";
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const UserAvatar = ({ user = {}, size = "md", linkToProfile = false, className = "" }) => {
  const cfg = SIZES[size] || SIZES.md;
  const { px, font, badge } = cfg;
  const url = user.avatar_url || user.avatarUrl || user.picture;
  const verified = user.is_verified || user.isVerified;
  const name = user.display_name || user.displayName || user.name || user.username || "Trader";
  const username = user.username;

  const inner = (
    <div
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
      style={{
        width: px,
        height: px,
        background: url ? "transparent" : "linear-gradient(135deg, #f5a623, #e8941a)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.35)",
      }}
      data-testid={`user-avatar-${username || user.id || "anon"}`}
    >
      {url ? (
        <img
          src={url}
          alt={name}
          loading="lazy"
          decoding="async"
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <span
          style={{
            color: "#0a0b16",
            fontWeight: 800,
            fontSize: font,
            letterSpacing: "0.02em",
            lineHeight: 1,
          }}
        >
          {initials(name)}
        </span>
      )}
      {verified && (
        <span
          aria-label="verified"
          style={{
            position: "absolute",
            right: -2,
            bottom: -2,
            width: badge,
            height: badge,
            borderRadius: "50%",
            background: "#00d4ff",
            border: "2px solid #07080f",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#07080f",
            fontSize: Math.max(8, badge - 8),
            fontWeight: 900,
          }}
        >
          ✓
        </span>
      )}
    </div>
  );

  if (linkToProfile && username) {
    return (
      <Link to={`/shadow/perfil/${username}`} className="inline-block">
        {inner}
      </Link>
    );
  }
  return inner;
};

export default UserAvatar;
